import { Box, Flex, Text } from '@chakra-ui/react';
import { customersDirectoryStyles } from '@texas/resources/theme/styles/customersDirectory';
import { useTranslation } from 'react-i18next';
import { SearchFilterInput } from '../SearchFilterInput';
import { NewCustomer } from '../customer/newCustomer/NewCustomer';
import { BodyOverride } from '../shared/BodyOverride';
import { DataTableContainer } from '../shared/dataTable/DataTableContainer';
import { EntityDirectoryFilterBar } from '../shared/entityDirectory/EntityDirectoryFilterBar';
import { EntityDirectoryPage } from '../shared/entityDirectory/EntityDirectoryPage';
import { TexasSwitch } from '../shared/form/TexasSwitch';
import { useCustomersColumns } from './hooks/useCustomersColumns';
import { CustomerScopeFilter } from './CustomerScopeFilter';
import { CustomerRoleFilter } from './CustomerRoleFilter';
import { CustomerTypeFilter } from './CustomerTypeFilter';
import { useCustomersDirectoryController } from './hooks/useCustomersDirectoryController';

export function CustomersDirectory() {
  const { t } = useTranslation();
  const {
    customers,
    error,
    firstItem,
    includeArchived,
    lastItem,
    loading,
    page,
    pageSize,
    searchTerm,
    selectedCustomerType,
    selectedCurrentUserRole,
    showAssignedToCurrentUser,
    sortBy,
    sortDesc,
    totalItems,
    setCustomerType,
    setCurrentUserRole,
    setIncludeArchived,
    setPage,
    setScope,
    setSearchTerm,
    setSorting,
  } = useCustomersDirectoryController();

  const columns = useCustomersColumns();

  return (
    <BodyOverride>
      <EntityDirectoryPage
        actions={
          <NewCustomer
            buttonLabel={t('general.newBrand')}
            buttonProps={{
              sx: customersDirectoryStyles.createButton,
              variant: 'entityDirectoryPrimary',
            }}
          />
        }
        description={t('brandsDirectory.description')}
        title={t('general.brands')}
      >
        <Flex sx={customersDirectoryStyles.content}>
          <EntityDirectoryFilterBar
            actions={
              <Box sx={customersDirectoryStyles.actions}>
                <TexasSwitch
                  checked={includeArchived}
                  label={t('general.includeArchived')}
                  onChange={setIncludeArchived}
                />
              </Box>
            }
          >
            <Box sx={customersDirectoryStyles.search}>
              <SearchFilterInput
                style="entityDirectory"
                value={searchTerm}
                placeholder={t('brandsDirectory.searchBrands')}
                onChange={setSearchTerm}
              />
            </Box>
            <CustomerScopeFilter
              value={showAssignedToCurrentUser}
              onChange={setScope}
            />
            <CustomerTypeFilter
              value={selectedCustomerType}
              onChange={setCustomerType}
            />
            <CustomerRoleFilter
              value={selectedCurrentUserRole}
              onChange={setCurrentUserRole}
            />
          </EntityDirectoryFilterBar>

          <Box>
            <DataTableContainer
              sx={customersDirectoryStyles.table}
              datatable={{
                data: customers,
                sorted: {
                  onSortedChange: ({ key, desc }) => setSorting(key, desc),
                  key: sortBy,
                  desc: sortDesc,
                },
                isLoading: loading,
                columns,
                variant: 'entity-directory',
              }}
              error={error}
              footer={
                <Text sx={customersDirectoryStyles.results}>
                  {t('brandsDirectory.showingResults', {
                    first: firstItem,
                    last: lastItem,
                    total: totalItems,
                  })}
                </Text>
              }
              pagination={{
                totalItems,
                pageSize,
                currentPage: page,
                onPageChange: setPage,
                variant: 'entityDirectoryPagination',
              }}
            />
          </Box>
        </Flex>
      </EntityDirectoryPage>
    </BodyOverride>
  );
}
